import { render, staticRenderFns } from "./ques61.vue?vue&type=template&id=6ed31c92&scoped=true"
import script from "./ques61.vue?vue&type=script&lang=js"
export * from "./ques61.vue?vue&type=script&lang=js"
import style0 from "./ques61.vue?vue&type=style&index=0&id=6ed31c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed31c92",
  null
  
)

export default component.exports